import { render, staticRenderFns } from "./JWTVLP.vue?vue&type=template&id=360facba&scoped=true"
import script from "./JWTVLP.vue?vue&type=script&setup=true&lang=ts"
export * from "./JWTVLP.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./JWTVLP.vue?vue&type=style&index=0&id=360facba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360facba",
  null
  
)

export default component.exports